export default "__VITE_ASSET__Bp_7sVf$__"